// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__EOBCG","alert":"Alert_alert__q4CAZ","close":"Alert_close__UyrAA"};